import React, { memo } from 'react';
import './css/HomePage1Section5.css';
import HomePage1Players from '../uiElements/homePage1Players/HomePage1Players';

const HomePage1Section5 = () => {
    return (
        <div className="homepage1-section5-container full-width">
            <HomePage1Players />
        </div>
    );
};

export default memo(HomePage1Section5);
